import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '../../styles/style-utils';
import { type } from '../../styles/typography';

const Band = styled.div`
  ${type('poster', 'large', { emphasis: true, uppercase: true })};
  padding: 24px var(--b-gutter);
  color: var(--b-black);
  overflow: hidden;
  white-space: nowrap;
`;

const Every = styled(Band)`
  background-color: var(--b-sky);

  ${media.large`
    padding-left: 300px;
  `};
`;

const Moment = styled(Band)`
  background-color: var(--b-mint);
  text-align: right;

  ${media.large`
    padding-right: 192px;
  `};
`;

const Marquee = ({ leading, trailing }) => (
  <div aria-hidden="true">
    <Every>{leading}</Every>
    <Moment>{trailing}</Moment>
  </div>
);

Marquee.propTypes = {
  leading: PropTypes.node,
  trailing: PropTypes.node,
};

Marquee.defaultProps = {
  leading: 'Every',
  trailing: 'Moment',
};

export default Marquee;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/Marquee.js